import React, { useEffect, useRef } from 'react'
import { PageTab } from 'shared/components/page-tab/page-tab'
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group'
import { PageTabList } from 'shared/components/page-tab/page-tab-list'
import { twJoin } from 'tailwind-merge'

export type ItemTabType<T> = { key: T; caption: string; hasError: boolean }

interface ItemTabsProps<T extends string> {
  tabs: ItemTabType<T>[]
  currentTab: T
  setTab: (tab: T) => void
}

const ItemTabs = <T extends string>({ tabs, currentTab, setTab }: ItemTabsProps<T>) => {
  const ref = useRef<HTMLDivElement>(null)

  const hasErrors = tabs.some(tab => tab.hasError)

  useEffect(() => {
    if (!hasErrors) return
    if (!ref.current) return

    ref.current.style.scrollMarginTop = '20px'
    ref.current.scrollIntoView({ behavior: 'smooth' })
  }, [hasErrors])

  return (
    <div ref={ref}>
      <PageTabGroup selectedIndex={tabs.findIndex(el => el.key === currentTab)}>
        <PageTabList
          className={'w-auto translate-x-0 px-0 sm:translate-x-0 sm:px-0 md:translate-x-0 md:px-0'}
        >
          {tabs.map(tab => (
            <PageTab
              key={tab.key}
              className={twJoin('pb-3 pt-0', tab.hasError && 'text-danger')}
              onClick={() => setTab(tab.key)}
            >
              {tab.caption}
            </PageTab>
          ))}
        </PageTabList>
      </PageTabGroup>
    </div>
  )
}
export default ItemTabs
